/* global angular */
angular.module('ua5App')
    .directive('twitter', ['$location', function($location) {
        return {
            restrict: 'A',
            scope: {
                url: '@',
                text: '@'
            },
            link: function($scope, $element, $attrs) {
                var text;
                var url;

                $scope.$watch(function() {
                    return $scope.url;
                }, function() {
                    url = $scope.url ? encodeURIComponent($scope.url) : $location.absUrl();
                    $element[0].href = 'https://twitter.com/intent/tweet?text=' + text + '&url=' + url;
                });

                $scope.$watch(function() {
                    return $scope.text;
                }, function() {
                    text = $attrs.text ? encodeURIComponent($attrs.text) : '';
                    $element[0].href = 'https://twitter.com/intent/tweet?text=' + text + '&url=' + url;
                });
            }
        };
    }])
;
